import React from 'react';

import { Box } from '@wds/box';
import { t } from '@sm/intl';
import { Typography } from '@wds/typography';

import COPY from './copy';
import useEnterprisePageStyles from './useStyles';

export default function ContactUs(): JSX.Element {
  const { ContactList, FeatureItem, ListHeading, TypographyBolded } = useEnterprisePageStyles();

  return (
    <>
      <Box display="flex" flexDirection="column" p={4}>
        {/* Change div line below to following once wds/typography is changed to v3+ to inherit styling
        <Typography component="h4" weight="medium" variant="sectionTitle" align="left">
        also remove class in style file */}
        <h4 className={TypographyBolded}>{t(COPY.CONTACT_US_TODAY)}</h4>
        <p className={ListHeading}>{t(COPY.LEARN_MORE)}</p>
        <Box className={ContactList} element="ul">
          <Typography component="p" variant="body">
            <li className={FeatureItem}>{t(COPY.MANAGE_USERS)}</li>
            <li className={FeatureItem}>{t(COPY.CONFIDENTIAL_DATA)}</li>
            <li className={FeatureItem}>{t(COPY.FEEDBACK)}</li>
          </Typography>
        </Box>
      </Box>
    </>
  );
}
